/**
 * Represent a strapi image
 */

import { STRAPI } from "../loaders/global";
import Base from "./Base";

const BASE_URL = `${process.env.NEXT_PUBLIC_UPLOAD_BASE_URL}`;

class Image extends Base {
  constructor(data) {
    super();
    if (data) this._patch(data);
  }
  _patch(data) {
    data = data?.data ? data.data : data?.attributes ? data : null;
    if (!data) return;
    let d = data?.attributes;
    this.id = data.id ?? null;
    this.name = d.name ?? "";
    this._url = d.url;
    this.alternativeText = d.alternativeText ?? "";
    this.caption = d.caption ?? "";
    this.formats = d.formats ?? {};
    if (d?.formats) {
      Object.keys(d?.formats).forEach(
        (key) =>
          (this.formats[key] = {
            ...d.formats[key],
            url: !d.formats[key].url.startsWith("http")
              ? BASE_URL + d.formats[key].url
              : d.formats[key].url,
          })
      );
    }

    this.ext = d.ext ?? "";
  }

  alt(defaultAlt = "", add = null) {
    return this.alternativeText
      ? this.alternativeText + (add ? " " + add : "")
      : defaultAlt;
  }
  /**
   * @param {String} formatTarget
   */
  getMaxFormat(formatTarget) {
    let formatOrder = ["thumbnail", "small", "medium", "large"];
    let indexTarget = formatOrder.indexOf(formatTarget);
    let targetsFormat = formatOrder.splice(0, indexTarget + 1).reverse();
    let res = null;

    for (let i = 0; i < targetsFormat.length; i++) {
      const format = targetsFormat[i];

      try {
        res = this.formats[format].url;
        break;
      } catch (err) {}
    }
    if (!res) throw new Error("No formats found");
    return res;
  }

  load(format = "medium") {
    if (format == "url") return this.url;
    try {
      return BASE_URL + getMaxFormat(format);
    } catch (error) {
      try {
        return this.url;
      } catch (error) {
        return BASE_URL;
      }
    }
  }
  get url() {
    return BASE_URL + this._url;
  }
}

export default Image;
